// Constants
import defaultStoreValues from '../constants/defaultStoreValues';
import {OPERATOR} from '../constants/operator';

// Reducers
import eventsReducer from './eventsReducer';
import gamesReducer from './gamesReducer';
import systemReducer from './systemReducer';
import modalReducer from './modalReducer';
import settingsReducer from './settingsReducer';
import raceCardReducer from './raceCardReducer';
import platformReducer from './platformReducer';
import helpPagesReducer from './helpPagesReducer';
import accumulatorBoostPagesReducer from './accumulatorBoostPagesReducer';
import realityCheckWarningReducer from './realityCheckWarningReducer'
import demoplayNotificationReducer from './demoplayNotificationReducer'
import promoBetReducer from './promoBetReducer';

// import modules reducers
import sportsBookModule from '../ui-modules/sports-book';
import sportsBookSubModules from '../ui-modules/sports-book/modules';
import simplifiedModule from '../ui-modules/simplified';
import simplifiedSubModules from '../ui-modules/simplified/modules';

// NOTE: when new reducers are created at this level, they must be added to this array
let reducers = [
    eventsReducer,
    gamesReducer,
    systemReducer,
    modalReducer,
    settingsReducer,
    raceCardReducer,
    platformReducer,
    helpPagesReducer,
    accumulatorBoostPagesReducer,
    realityCheckWarningReducer,
    demoplayNotificationReducer,
    promoBetReducer
];
// concat module and submodule reducers into main reducers list
if (OPERATOR.clientType === 'Simplified') {
    reducers = reducers.concat(simplifiedModule.map((mod) => mod.reducers));
    reducers = reducers.concat(simplifiedSubModules.map((mod) => mod.reducers));
} else {
    reducers = reducers.concat(sportsBookModule.map((mod) => mod.reducers));
    reducers = reducers.concat(sportsBookSubModules.map((mod) => mod.reducers));
}

export default (state = defaultStoreValues, action = {}) => {
    let newState = state;

    for (let i = 0; i < reducers.length; i++) {
        newState = reducers[i](newState, action);
    }

    return newState;
};


// WEBPACK FOOTER //
// ./src/reducers/index.js